/**
 * extensionBridge.js
 *
 * Shared helpers for communicating with the RoundPrep Sync Chrome extension
 * via window.postMessage / content-script bridge.
 */

const SELF_ORIGIN = window.location.origin;
const EXTENSION_TIMEOUT_MS = 1500;

/** Returns true if the extension content script is present on this page. */
export function checkExtensionPresent() {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", handler);
      resolve(false);
    }, EXTENSION_TIMEOUT_MS);

    function handler(e) {
      if (e.origin !== SELF_ORIGIN) return;
      if (e.data?.source === "roundprep-ext" && e.data?.type === "PONG") {
        clearTimeout(timer);
        window.removeEventListener("message", handler);
        resolve(true);
      }
    }

    window.addEventListener("message", handler);
    window.postMessage({ source: "roundprep-page", type: "PING" }, SELF_ORIGIN);
  });
}

/** Ask the extension to fetch LeetCode progress. Resolves with the raw data object. */
export function requestLeetCodeSync(timeoutMs = 30_000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", handler);
      reject(new Error("Extension did not respond in time"));
    }, timeoutMs);

    function handler(e) {
      if (e.origin !== SELF_ORIGIN) return;
      if (e.data?.source === "roundprep-ext" && e.data?.type === "SYNC_RESULT") {
        clearTimeout(timer);
        window.removeEventListener("message", handler);
        resolve(e.data.data);
      }
    }

    window.addEventListener("message", handler);
    window.postMessage({ source: "roundprep-page", type: "START_SYNC" }, SELF_ORIGIN);
  });
}

/**
 * Ask the extension to fetch contest stats for a username from LeetCode's
 * public API (no auth required). Resolves with { contestsAttended, contestRating }.
 */
export function fetchContestStats(username, timeoutMs = 8000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", handler);
      reject(new Error("Extension did not respond in time"));
    }, timeoutMs);

    function handler(e) {
      if (e.origin !== SELF_ORIGIN) return;
      if (e.data?.source === "roundprep-ext" && e.data?.type === "CONTEST_STATS_RESULT") {
        clearTimeout(timer);
        window.removeEventListener("message", handler);
        resolve(e.data.data);
      }
    }

    window.addEventListener("message", handler);
    window.postMessage(
      { source: "roundprep-page", type: "FETCH_CONTEST_STATS", username },
      SELF_ORIGIN
    );
  });
}
